import { Action } from 'redux';

import { NlpSetting } from '../../datasource/models/IDataSourceInfo';
import { SetNlpSetting } from './AppActionTypes';

export interface SetNlpSettingAction extends Action {
  nlpSetting: NlpSetting;
}

export const setNlpSetting = (nlpSetting: NlpSetting): SetNlpSettingAction => ({
  type: SetNlpSetting,
  nlpSetting,
});
